import { Fragment } from 'react';
import EmojiText from './EmojiText';
import { splitTextByUrls } from '../lib/url';
import { contactReferenceHref, splitTextByContact } from '../lib/contactReference';

/** Текст сообщения: эмодзи — картинками, URL и проверенные ссылки на контакт — кликабельными. */
export default function MessageText({ text, entities }: { text: string; entities?: unknown }) {
  const segments = splitTextByContact(text, entities);
  return (
    <>
      {segments.flatMap((segment, segmentIndex) => segment.userId ? (
        <a
          key={`contact-${segmentIndex}`}
          href={contactReferenceHref(segment.userId, segment.text.slice(1))}
          className="msg-link"
          onClick={(e) => e.stopPropagation()}
        >
          {segment.text}
        </a>
      ) : splitTextByUrls(segment.text).map((part, partIndex) => (
        <Fragment key={`${segmentIndex}-${partIndex}`}>
          {part.url ? (
            <a
              href={part.url}
              target="_blank"
              rel="noopener noreferrer"
              className="msg-link"
              onClick={(e) => e.stopPropagation()}
            >
              {part.url}
            </a>
          ) : (
            <EmojiText text={part.text ?? ''} />
          )}
        </Fragment>
      )))}
    </>
  );
}
